// Live chat SupportBoxu (supportChat.js) a vstupy do něj v šabloně.
export default {
  /** aria-label plovoucího tlačítka */
  open: 'Otevřít chat',
  /** aria-label tlačítka, na které čeká nepřečtená odpověď */
  unread: 'Otevřít chat, máte novou odpověď',
  /** čtečka při načítání widgetu po kliku */
  loading: 'Načítáme chat',
  /** widget se nenačetl (blokovaný skript, výpadek) — odkaz na e-mail zůstává */
  failed: (email) => 'Chat se teď nepodařilo otevřít. Napište nám na ' + email + '.',
  /** vstup do chatu ve slotech „Napište nám" (karta poradce, poradna, pásy, kontakt) */
  cta: 'Napsat do chatu',
  /** vstup s otázkou k věci (vyprodaný produkt, výpadek sledování objednávky) */
  ask: 'Zeptat se v chatu',
  /** řádek pod tlačítkem do košíku na mobilním detailu: úvod + výzva (červeně) */
  buyboxLead: 'Máte dotaz?',
  buyboxCta: 'Napište nám do chatu',
  /** předvyplněné pole chatu otevřeného na detailu produktu (setChatTopic): agent Lucy podle něj najde produkt */
  productTopic: (name) => 'Dotaz k produktu ' + name + ': ',
};
